import { createGlobalStyle } from 'styled-components';

import { colors, typography } from './tokens';

export default createGlobalStyle`
 * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    outline: 0;

    /* width */
    ::-webkit-scrollbar {
      width: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: ${colors.surfaceContainerLowest};
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: ${colors.surfaceContainerHighest};
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: ${colors.outline};
    }
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    background: ${colors.surface};
    color: ${colors.onSurface};
    -webkit-font-smoothing: antialiased;
  }

  body, input, button, textarea, select {
    font-family: ${typography.fontFamily};
    font-size: 16px;
  }

  .material-symbols-outlined {
    font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24;
  }

  h1, h2, h3, h4, h5, h6, strong {
    font-weight: 500;
  }

  button {
    cursor: pointer;
  }


  :root {
    --st-modal-boxShadow: 0 10px 50px rgba(0, 0, 0, 0.8);
    --st-modal-borderRadius: 15px;

    --st-modal-transformVisible: translate3d(-50%, -50%, 0) scale(1) rotateX(0);

    --st-dialog-maxWidth: 900px;

    @media (max-width: 1199px) {
      --st-dialog-baseWidth: 90%;
      --st-dialog-maxWidth: 90%;
    }
  }

  /* Impressão de fichas (ex.: PrintWorkoutSheet) -- esconde o resto do
     app e mostra só o que estiver marcado com essa classe. O elemento em
     si controla sua própria visibilidade em tela (display: none) via
     @media print, então isso só entra em ação de fato durante a
     impressão. */
  @media print {
    body * {
      visibility: hidden;
    }

    .print-sheet,
    .print-sheet * {
      visibility: visible;
    }

    .print-sheet {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }
  }

`;
